import Vue from 'vue'
import VueMq from 'vue-mq'
import Router from 'vue-router'
import TransactionLookup from "../components/TransactionLookup";
import Receipt from "../components/Receipt";

Vue.use(VueMq, {
  breakpoints: {
    mobile: 450,
    tablet: 900,
    desktop: Infinity
  }
})

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Receipt',
      component: Receipt
    },
    {
      path: '/transaction-lookup',
      name: 'TransactionLookup',
      component: TransactionLookup
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js